<template>
  <SimpleTextPopup
    :title="title"
    v-model="value"
    @popupClose="$emit('input', false)"
    hideRgtBtn
    :outsideScrollToBottom="outsideScrollToBottom"
    large>
    <template v-slot:input>
      <v-container>
        <PaginationController
          v-model="changeLogs"
          :getDataActionName="actionName"
          :historyLimit="historyLimit"
          haveSearchBox
          :searchBoxLabel="`${$t('upc')}/${$t('trackingNumber')}`"
          haveNoEndDate
          :outsideScrollToBottom="popupToBottom"
        >
          <template v-slot:dataTable>
            <v-data-table
              :headers="headers"
              :items="logs"
              class="elevation-2 myDense"
              hide-actions>
              <template v-slot:items="props">
                <td class="subheading">
                  <v-layout row no-wrap>
                    {{ props.index + 1}}
                    <v-icon color="red" v-if="props.item.beforeValue[0].isAbnormal">flag</v-icon>
                  </v-layout>
                </td>
                <td class="text-xs-left">{{ toTimestampString(props.item.createTime) }}</td>
                <td v-if="headers[2].text === $t('tracking')" >
                  <v-layout style="height: 100%" column justify-space-between>
                    <v-layout align-center v-for="(tracking, index) in props.item.trackings" 
                    :key="'item' + index">{{tracking}}</v-layout>
                  </v-layout>
                </td>
                <td class="text-xs-left">                   
                  <div
                    v-for="(item, index) in props.item.beforeValue" 
                    :key="'item' + index"
                  >
                    <v-layout>{{upcMap[item.upc] ? upcMap[item.upc].description : 'New product'}}</v-layout>
                    <v-layout :class="item.upc !== props.item.actionPayload[index].upc ? 'font-green' : ''">{{ $t('upc') }}: {{item.upc}}</v-layout>
                    <v-layout :class="item.quantity !== props.item.actionPayload[index].quantity ? 'font-green' : ''">{{ $t('quantity') }}: {{item.quantity}}</v-layout>
                    <template v-if="item.isAbnormal">
                      <v-layout 
                        :class="item.abnormalQty !== props.item.actionPayload[index].abnormalQty ? 'font-green' : ''"
                        >{{ $t('abnormalQuantity') }}: {{item.abnormalQty}}</v-layout>
                      <v-layout 
                        :class="item.normalQty !== props.item.actionPayload[index].normalQty ? 'font-green' : ''"
                        >{{ $t('normalQuantity') }}: {{item.normalQty}}</v-layout>
                    </template>
                    <v-layout :class="item.organizationId !== props.item.actionPayload[index].organizationId ? 'font-green' : ''">{{ $t('organizationId') }}: {{item.organizationId}}</v-layout>
                  </div> 
                </td>
                <td class="text-xs-left">                   
                  <div
                    v-for="(item, index) in props.item.actionPayload" 
                    :key="'item' + index"
                  >
                    <v-layout>{{upcMap[item.upc] ? upcMap[item.upc].description : 'New product'}}</v-layout>
                    <v-layout>{{ $t('upc') }}: {{item.upc}}</v-layout>
                    <v-layout>{{ $t('quantity') }}: {{item.quantity}}</v-layout>
                    <template v-if="item.isAbnormal">
                      <v-layout 
                        >{{ $t('abnormalQuantity') }}: {{item.abnormalQty}}</v-layout>
                      <v-layout 
                        >{{ $t('normalQuantity') }}: {{item.normalQty}}</v-layout>
                    </template>
                    <v-layout>{{ $t('organizationId') }}: {{item.organizationId}}</v-layout>
                  </div> 
                </td>
                <td class="text-xs-left">{{ props.item.userInfo.userName }}</td>
                <td class="text-xs-left">{{ props.item.siteName }}</td>
                <td v-if="actionName === 'getAdjustLogs'" style="white-space: pre-wrap;" :class="noteClass">{{ props.item.note }}</td>
              </template>
            </v-data-table>
          </template>
        </PaginationController>
      </v-container>
    </template>
  </SimpleTextPopup>
</template>

<script>
import SimpleTextPopup from './SimpleTextPopup'
import PaginationController from './PaginationController'
import {timeTools} from '../utils/tools'

export default {
  name: 'WarehouseChangelogs',
  components: {
    SimpleTextPopup,
    PaginationController
  },
  mixins: [timeTools],
  data () {
    return {
      headers: [
        { text: '#', align: 'left', sortable: false, width: '5%' },
        { text: this.$t('createTime'), value: 'uid', align: 'left', sortable: false },
        { text: this.$t('tracking'), value: 'siteName', align: 'left', sortable: false },
        { text: this.$t('before'), value: 'price', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('after'), value: 'quantity', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('operator'), value: '', align: 'left', sortable: false },
        { text: this.$t('siteName'), value: 'createTime', align: 'left', sortable: false }
      ],
      changeLogs: [],
      historyLimit: 20,
      popupToBottom: false,
      actionName: 'getChangeLogs',
      title: this.$t('changeLogs')
    }
  },
  computed: {
    logs () {
      return this.changeLogs.map(item => {
        item.trackings = item.actionPayload.map(payload => payload.trackings[0])
        item.siteName = item.actionPayload[0].siteName
        item.actionPayload.forEach(ele => {
          ele.organizationId = this.organizationKeyToId.get(ele.organizationKey)
        })
        item.beforeValue.forEach(ele => {
          ele.organizationId = this.organizationKeyToId.get(ele.organizationKey)
        })
        return item
      })
    },
    organizationKeyToId () {
      return this.$store.getters.organizationKeyToId
    },
    upcMap () {
      return this.$store.getters.upcMap
    },
    noteClass () {
      return this.$vuetify.breakpoint.smAndDown ? 'offerLink-small' : (this.$vuetify.breakpoint.mdOnly ? 'offerLink-medium' : (this.$vuetify.breakpoint.lgOnly ? 'offerLink-large' : 'offerLink-xlarge'))
    }
  },
  methods: {
    outsideScrollToBottom (flag) {
      this.popupToBottom = flag
    }
  },
  props: {
    value: Boolean
  }
}
</script>

<style>
.offerLink-xlarge, .offerLink-xlarge .offer-widget {
  overflow-wrap: break-word !important;
  max-width: 30vw !important;
  white-space: pre-wrap;
}

.offerLink-large, .offerLink-large .offer-widget {
  overflow-wrap: break-word !important;
  max-width: 20vw !important;
  white-space: pre-wrap;
}

.offerLink-medium, .offerLink-medium .offer-widget {
  overflow-wrap: break-word !important;
  max-width: 15vw !important;
  white-space: pre-wrap;
}

.offerLink-small, .offerLink-small .offer-widget {
  overflow-wrap: break-word !important;
  max-width: 15vw;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/WarehouseChangeLogs.vue